import { Component, Inject, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

import { FormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { MatDialogModule } from '@angular/material/dialog'
import { TooltipModule } from 'primeng/tooltip'

@Component({
  selector: 'app-show-hide-column-dialog',
  standalone: true,
  imports: [FormsModule, TranslatePipe, MatDialogModule, TooltipModule],
  templateUrl: './show-hide-column-dialog.component.html',
  styleUrl: './show-hide-column-dialog.component.scss'
})
export class ShowHideColumnDialogComponent implements OnInit {
  currentLanguage: string | null = ''
  formGroup!: FormGroup
  headers: any[] = []
  truncateLength = 20
  messageTranslationPrefix!: string
  constructor(
    public dialogRef: MatDialogRef<ShowHideColumnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.currentLanguage = localStorage.getItem('lang') || 'en'
  }

  ngOnInit(): void {
    this.messageTranslationPrefix = this.data.messageTranslationPrefix
    this.headers = this.data.headers
    if (this.data.truncateLength) {
      this.truncateLength = this.data.truncateLength
    }

    const rawData = localStorage.getItem(this.messageTranslationPrefix)
    if (rawData) {
      const savedSettings = JSON.parse(rawData)

      const savedColsArray = Array.isArray(savedSettings)
        ? savedSettings
        : savedSettings.activeColumns

      if (Array.isArray(savedColsArray)) {
        this.headers = this.headers.map((col) => ({
          ...col,
          isActive:
            savedColsArray.find((s: any) => s.key === col.key)?.isActive ??
            col.isActive
        }))
      }
    }
  }

  close(): void {
    this.dialogRef.close(false)
  }

  private saveDisplayedColumns() {
    const rawData = localStorage.getItem(this.messageTranslationPrefix)
    const existingSettings = rawData ? JSON.parse(rawData) : {}
    const columnSettings = this.headers.map((col) => ({
      key: col.key,
      isActive: col.isActive
    }))
    const updatedData = {
      ...existingSettings,
      activeColumns: columnSettings
    }

    localStorage.setItem(
      this.messageTranslationPrefix,
      JSON.stringify(updatedData)
    )
  }
  saveHeaders() {
    this.saveDisplayedColumns()
    this.dialogRef.close(this.headers)
  }
}
